<template>
    <div>
        <b-modal 
            no-stacking
            v-model="conditionArea.show"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-footer  
            size="lg"
            @hidden="$emit('close')"     
        >
            <div class="container-fluid pb-3">
                <div class="row mb-1 text-center px-lg-6">
                    <div class="col-12 mb-3">
                        <img :src="iconMap" alt="ConditionArea" />
                        <h2 class="pt-1">เงื่อนไขพื้นที่การให้บริการ แพ็กเกจ {{detailConditionArea.header}}</h2>
                        <div class="text-left">
                            <h3>ร้านของคุณจะต้องมียอดการจัดส่งพัสดุ <span class="text-primary">จำนวนมากกว่า 30 ชิ้นต่อเดือน ภายใน 3 เดือน</span> นับ ตั้งแต่วันที่สมัครตามหน้าหนังสือสัญญา</h3>
                            <h3>หากยอดการจัดส่งไม่ถึงตามที่กำหนด ร้าน SHIPPOP SHOP รายอื่นสามารถเปิดร้านได้ในพื้นที่ ระยะห่าง <span class="text-primary">{{detailConditionArea.kilo}}</span>จากร้านของคุณ </h3>
                            <h5 class="text-muted">*เงื่อนไขเป็นไปตามสัญญาที่บริษัทฯกำหนด</h5>
                        </div>
                        <b-button variant="info" @click="conditionArea.show = false">ตกลง</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModalConditionArea" ,
    props: {
        conditionArea: Object,
    },
    data() {
        return {
            iconMap: require('../../../assets/images/icon-map.svg'),
        }
    },
    computed: {
        detailConditionArea(){
            if(this.conditionArea.package == 'POP'){
                return {
                    header: "POP",
                    kilo:"0 กิโลเมตร",
                }
            }else if(this.conditionArea.package == 'POPPLUS'){
                return {
                    header: "POP+",
                    kilo:"500 เมตร",
                }
            }else{
                return {
                    header: "SHOP",
                    kilo:"3 กิโลเมตร",
                }
            }
        }
    }
}
</script>